// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PrimaryKeyRequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {ProgramEnvironmentalBenefit} from './ProgramEnvironmentalBenefit';
import {ContextNodeDetails} from './ContextNodeDetails';
import {ContextNodeSpeciesList} from './ContextNodeSpeciesList';
import {ProgramConfirmationAgency} from './ProgramConfirmationAgency';
import {Organization} from './Organization';
import {Project} from './Project';
import {ContextNodeQuickLink} from './ContextNodeQuickLink';

const _associations = [
			{
				name: 'ProgramEnvironmentalBenefits',
				model: new ProgramEnvironmentalBenefit(),
				type: 'ArrayOfChildren',
				using: 'programId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: 'update_program_benefits',
				group: 'Environmental Benefits',
				groupTitle: 'Environmental Benefits',
				displayOrder: 15,
				itemTitle: 'Environmental Benefit',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: 'StreamBankProgramEnvBenefitsMutableList',
				customData: {
				}
			},
			{
				name: 'ContextNodeDetails',
				model: new ContextNodeDetails(),
				type: 'ParentPointer',
				using: 'contextNodeId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'ContextNodeDetails',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ContextNodeSpeciesList',
				model: new ContextNodeSpeciesList(),
				type: 'ArrayOfChildren',
				using: 'contextNodeId',
				isHidden: {
					requiresPermission: 'can_view_species_list'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: 'This species list will be used as the default for all Projects under this Program / Sub-Program.',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 12,
				itemTitle: 'Default Species List',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ProgramConfirmationAgencies',
				model: new ProgramConfirmationAgency(),
				type: 'ArrayOfChildren',
				using: 'programId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 13,
				itemTitle: 'Confirmation Agencies',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'Organization',
				model: new Organization(),
				type: 'ParentPointer',
				using: 'organizationId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'Organization',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'Projects',
				model: new Project(),
				type: 'ArrayOfChildren',
				using: 'programId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'Projects',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ContextNodeQuickLinks',
				model: new ContextNodeQuickLink(),
				type: 'ArrayOfChildren',
				using: 'contextNodeId',
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: null,
				group: 'Quick Links',
				groupTitle: 'Quick Links',
				displayOrder: 14,
				itemTitle: 'Quick Link',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: 'StreamBankMutableList',
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'programId',
				placeholder: null,
				key: 'programId',
				isPrimaryKey: true,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.programId,
				setter: (x, y) => x.programId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new PrimaryKeyRequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Program Name',
				placeholder: null,
				key: 'name',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 2,
				getter: (x) => x.name,
				setter: (x, y) => x.name = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Short Name',
				placeholder: null,
				key: 'shortName',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: 'Shorter version of program name above. Useful for report titles, graph labels, and other character-constrained items.',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 3,
				getter: (x) => x.shortName,
				setter: (x, y) => x.shortName = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Nickname',
				placeholder: null,
				key: 'nickname',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 4,
				getter: (x) => x.nickname,
				setter: (x, y) => x.nickname = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'slug',
				placeholder: null,
				key: 'slug',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.slug,
				setter: (x, y) => x.slug = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Parent Program',
				placeholder: null,
				key: 'parentProgramId',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: {
					query: 'parentProgramId == null',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 5,
				getter: (x) => x.parentProgramId,
				setter: (x, y) => x.parentProgramId = y,
				defaultValue: null,
				editor: 'RootProgramFieldEditor',
				viewer: 'ProgramFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Start Date',
				placeholder: null,
				key: 'startDate',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 6,
				getter: (x) => x.startDate,
				setter: (x, y) => x.startDate = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Program Length',
				placeholder: null,
				key: 'programLength',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 8,
				getter: (x) => x.programLength,
				setter: (x, y) => x.programLength = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
					new validators.NumberOfDecimalsValidator(0),
					new validators.UnsignedNumberValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
					suffix: "years",
				}
			},
			{
				title: 'Program Manager',
				placeholder: null,
				key: 'programManagerId',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'view_contact'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: 'Program Manager contact info is included in reports',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 7,
				getter: (x) => x.programManagerId,
				setter: (x, y) => x.programManagerId = y,
				defaultValue: null,
				editor: 'ContactFieldEditor',
				viewer: 'ContactFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Goals Description',
				placeholder: null,
				key: 'goalsDescription',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Description',
				groupTitle: 'Description',
				displayOrder: 11,
				getter: (x) => x.goalsDescription,
				setter: (x, y) => x.goalsDescription = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(4000),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Area Description',
				placeholder: null,
				key: 'areaDescription',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: 'Description',
				groupTitle: 'Description',
				displayOrder: 12,
				getter: (x) => x.areaDescription,
				setter: (x, y) => x.areaDescription = y,
				defaultValue: null,
				editor: 'TextAreaEditor',
				viewer: 'TextAreaViewer',
				validators: [
					new MaxLengthValidator(4000),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Info Title',
				placeholder: null,
				key: 'infoTitle',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: 'If set, an information icon will be displayed with this text.',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 14,
				getter: (x) => x.infoTitle,
				setter: (x, y) => x.infoTitle = y,
				defaultValue: '',
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Info Link',
				placeholder: null,
				key: 'infoLink',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: 'If set, the information icon will be a hyperlink to this URL.',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 15,
				getter: (x) => x.infoLink,
				setter: (x, y) => x.infoLink = y,
				defaultValue: '',
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deleted',
				placeholder: null,
				key: 'deleted',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deleted,
				setter: (x, y) => x.deleted = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'attributes',
				placeholder: null,
				key: 'attributes',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.attributes,
				setter: (x, y) => x.attributes = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Organization',
				placeholder: null,
				key: 'organizationId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: {
					query: 'parentProgramId != null || (programId != null && editMode)',
					requiresPermission: 'skips_data_segmentation'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: ["skips_data_segmentation","authenticated_user"],
				group: '',
				groupTitle: null,
				displayOrder: 1,
				getter: (x) => x.organizationId,
				setter: (x, y) => x.organizationId = y,
				defaultValue: null,
				editor: 'OrganizationFieldEditor',
				viewer: 'OrganizationFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Map Caption',
				placeholder: null,
				key: 'programMapCaption',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 10,
				getter: (x) => x.programMapCaption,
				setter: (x, y) => x.programMapCaption = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(2000),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'contextNodeId',
				placeholder: null,
				key: 'contextNodeId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.contextNodeId,
				setter: (x, y) => x.contextNodeId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Map File',
				placeholder: null,
				key: 'programMapFileUploadId',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 9,
				getter: (x) => x.programMapFileUploadId,
				setter: (x, y) => x.programMapFileUploadId = y,
				defaultValue: null,
				editor: 'FileUploadFieldEditorWithOverlay',
				viewer: 'FileUploadFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
					contextNodeIdFetch: (x) => [x.contextNodeId],
				}
			},
			{
				title: 'Document File',
				placeholder: null,
				key: 'programDocFileUploadId',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'authenticated_user'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 8,
				getter: (x) => x.programDocFileUploadId,
				setter: (x, y) => x.programDocFileUploadId = y,
				defaultValue: null,
				editor: 'FileUploadFieldEditorWithOverlay',
				viewer: 'FileUploadFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
					contextNodeIdFetch: (x) => [x.contextNodeId],
				}
			},
			{
				title: 'parentSlug',
				placeholder: null,
				key: 'parentSlug',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.parentSlug,
				setter: (x, y) => x.parentSlug = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'totalProjects',
				placeholder: null,
				key: 'totalProjects',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.totalProjects,
				setter: (x, y) => x.totalProjects = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'totalArea',
				placeholder: null,
				key: 'totalArea',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.totalArea,
				setter: (x, y) => x.totalArea = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'totalProjectsPending',
				placeholder: null,
				key: 'totalProjectsPending',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.totalProjectsPending,
				setter: (x, y) => x.totalProjectsPending = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'totalAreaPending',
				placeholder: null,
				key: 'totalAreaPending',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.totalAreaPending,
				setter: (x, y) => x.totalAreaPending = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'contextPath',
				placeholder: null,
				key: 'contextPath',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.contextPath,
				setter: (x, y) => x.contextPath = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'startYear',
				placeholder: null,
				key: 'startYear',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.startYear,
				setter: (x, y) => x.startYear = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'endYear',
				placeholder: null,
				key: 'endYear',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.endYear,
				setter: (x, y) => x.endYear = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'assignedSpeciesListId',
				placeholder: null,
				key: 'assignedSpeciesListId',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.assignedSpeciesListId,
				setter: (x, y) => x.assignedSpeciesListId = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'parentAssignedSpeciesListId',
				placeholder: null,
				key: 'parentAssignedSpeciesListId',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.parentAssignedSpeciesListId,
				setter: (x, y) => x.parentAssignedSpeciesListId = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class Program extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [
			new validators.NoDuplicateAssociationsValidator('ProgramConfirmationAgencies', ['confirmationAgencyId']),
		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
